/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VacancyFields } from './vacancyFields';
import { AcademicLevelFilterOrder } from './academicLevelFilterOrder';
import { VacancyIncludeFilterInner } from './vacancyIncludeFilterInner';


export interface VacancyFilter1 { 
    offset?: number;
    limit?: number;
    skip?: number;
    order?: AcademicLevelFilterOrder;
    fields?: VacancyFields;
    include?: Array<VacancyIncludeFilterInner>;
}

